import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import { logout } from "../../store/Slice/authSlice";
import authService from "../../Services/auth.service";
import { useNavigate } from "react-router-dom";
import MenuSideBar from "../Menu/MenuSideBar";
// import Notification from "../Notification/Notification";
import KeyIcon from "@mui/icons-material/Key";
import UpdatePassword from "../Password/UpdatePassword";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Swal from "sweetalert2";
import { URL_IMAGE } from "../../Config";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  backgroundColor: "#A084DC",
  color: "#fff",
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

export default function Header({ open, handleDrawerOpen, handleDrawerClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector(({ auth }) => auth);
  const setting = useSelector(({ setting }) => setting);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const users = auth.isLoggedIn ? authService.auth() : null;
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleDrawerClose();

    Swal.fire({
      title: "คุณต้องการออกจากระบบหรือไม่",
      text: users ? users.fname + "  " + users.lname : "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FF8C00",
      cancelButtonColor: "#FF4500",
      confirmButtonText: "LogOut",
      cancelButtonText: "ยกเลิก",
      customClass: {
        title: "sweetalert-title", // Apply Sarabun font to the title
        content: "sweetalert-content", // Apply Sarabun font to the content
        confirmButton: "sweetalert-confirm-button",
        cancelButton: "sweetalert-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout())
          .unwrap()
          .then(() => {
            navigate("/");
            document.body.classList.add("login-background");
          });
      }
    });
  };

  const [openUpPassword, setOpenUpPassword] = React.useState(false);

  const handleClickOpenUpPassword = () => {
    setOpenUpPassword(true);
  };

  const handleCloseUpPassword = () => {
    setOpenUpPassword(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: auth.isLoggedIn ? "flex" : "none",
          background: "#4F4F4F",
        }}
        open={open}
      >
        <Toolbar>
          {auth.isLoggedIn && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              disabled={users?.group_id === "4"}
              edge="start"
              sx={{ mr: 2 }}
            >
              <MenuIcon sx={{ color: "#fff" }} />
            </IconButton>
          )}
          {/* <Box sx={{ display: { xs: "none", md: "flex" }, width: "12%" }}>
            <Typography variant="h6" noWrap component="div" sx={{ mr: 2 }}>
              {setting.detail_name}
            </Typography>
          </Box> */}
          <Box sx={{ flexGrow: 1 }}></Box>
          {auth.isLoggedIn && (
            <div>
              <Stack direction="row" spacing={1}>
                <Button
                  variant="outlined"
                  sx={{ display: { xs: "flex", md: "none" } }}
                  color="inherit"
                  size="small"
                  onClick={handleMenu}
                >
                  <AccountCircle />
                </Button>
                <Button
                  variant="outlined"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  // size="small"
                  onClick={handleMenu}
                  // startIcon={<AccountCircle />}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="dot"
                    sx={{ mr: 2 }}
                  >
                    <AccountCircle sx={{ fontSize: 30 }} />
                  </StyledBadge>
                  <Typography variant="body2" noWrap component="div">
                    {users ? users.fname + "  " + users.lname : ""}
                  </Typography>
                </Button>
              </Stack>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <Box
                  p={1}
                  sx={{
                    minWidth: 200,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                      }}
                    >
                      <AccountCircleIcon
                        fontSize="large"
                        sx={{ mr: 1, color: "primary.main" }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold" }}
                        noWrap
                      >
                        {users ? users.fname + "  " + users.lname : ""}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        mt: 1,
                        pl: 5,
                      }}
                    ></Box>
                    <Chip
                      avatar={
                        <Avatar
                          alt="logo"
                          src={URL_IMAGE + setting.detail_logo}
                        />
                      }
                      label={setting.detail_name}
                      sx={{
                        backgroundColor: "#d5f5d5",
                        color: "#37cf37",
                        fontWeight: "bold",
                        mt: 1,
                      }}
                    />
                  </Stack>
                </Box>
                <Divider />
                <MenuItem
                  disabled={users?.group_id === "4"}
                  onClick={() => {
                    handleClickOpenUpPassword();
                  }}
                >
                  <ListItemIcon>
                    <KeyIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Change Password</ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleLogout();
                    setAnchorEl(null);
                  }}
                >
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>LogOut</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
        <UpdatePassword
          open={openUpPassword}
          handleClose={handleCloseUpPassword}
        />
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            // backgroundColor: "rgb(40, 36, 61)",
            // color: "#fff",
            pr: 1,
          },
        }}
        variant="temporary"
        anchor="left"
        open={open}
        onClose={handleDrawerOpen}
      >
        <DrawerHeader color="primary"></DrawerHeader>
        {auth.isLoggedIn && <MenuSideBar handleDrawerOpen={handleDrawerOpen} />}
      </Drawer>
    </>
  );
}
